import React, { ReactNode } from 'react';

import { Link } from 'react-router-dom';

import './left-navigation-bar.scss';

type TDashboardProps = {
  LeftNavigationBarLinks?: {
    title: string | JSX.Element;
    img: ReactNode;
    link: string;
  }[];
};

export const LeftNavigationBar = ({
  LeftNavigationBarLinks,
}: TDashboardProps): JSX.Element => {
  const pathname = window.location.pathname;

  return (
    <div className="left-navigation-bar">
      {LeftNavigationBarLinks &&
        LeftNavigationBarLinks.map((item) => (
          <Link
            to={item.link}
            className={
              item.link === pathname
                ? 'left-navigation-bar__block active'
                : 'left-navigation-bar__block'
            }
            key={item.link}
          >
            <span className="link-img">{item.img}</span>
            <span className="link-name">{item.title}</span>
          </Link>
        ))}
    </div>
  );
};
